import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { isPrerender } from '../utils/isPrerender';
import { matchDate } from '../utils/utils';
import SectionTitle from './SectionTitle';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ProchainsMatch = () => {
  const {
    equipesProchainMatchs,
    prochainsMatchs,
    prochainsMatchsLoading,
    prochainsMatchsError,
    fetchProchainsMatchs
  } = useData();

  useEffect(() => {
    if (isPrerender()) return;
    fetchProchainsMatchs();
  }, [fetchProchainsMatchs]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
  };

  return (
    <div className='section section--seam section--blue ccontainer-prochain-match'>
      <SectionTitle overline="Compétition">Nos prochains matchs</SectionTitle>
      <div className="text-center">
        {prochainsMatchsLoading ? (
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        ) : prochainsMatchsError ? (
          <div>Erreur: {prochainsMatchsError}</div>
        ) : equipesProchainMatchs.length > 0 ? (
          <Slider {...settings}>
            {equipesProchainMatchs.map((equipe, index) => (
              <div key={`${equipe.idequipe}-${index}`}>
                <h3 className='text-center'>{equipe.libequipe}</h3>
                {prochainsMatchs[equipe.idequipe] ? (
                  <div>
                    <p className='text-center date-prochain-match'>
                      {matchDate(prochainsMatchs[equipe.idequipe])}
                    </p>
                    <div className='container-prochain-match'>
                      <div className='nom-equipe'>
                        {prochainsMatchs[equipe.idequipe].equa || 'AUCUNE EQUIPE'}
                      </div>
                      <div className='prochain-match-score'>
                        <div className='score'>{prochainsMatchs[equipe.idequipe].scorea}</div>
                        <div>VS</div>
                        <div className='score'>{prochainsMatchs[equipe.idequipe].scoreb}</div>
                      </div>
                      <div className='nom-equipe'>
                        {prochainsMatchs[equipe.idequipe].equb || 'AUCUNE EQUIPE'}
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className='text-center'>Aucun match à venir.</p>
                )}
              </div>
            ))}
          </Slider>
        ) : (
          <div className='container-aucun-match'>Aucun match pour le moment.</div>
        )}
      </div>
      <div className='container-btn text-center'>
        <Link className="btn btn-secondary" to="/matchs">Voir plus</Link>
      </div>
    </div>
  );
};

export default ProchainsMatch;
